const palette = {
  primary: {
    main: '#000',
    dark: '#919191',
    light: '#8cef1f',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#919191',
    dark: '#B5B5B5',
    light: '#f6f7f8',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#79C91F',
    dark: '#A3C41E',
    light: '#8cef1f',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D32F2F',
    dark: '#C62828',
    light: '#EF5350',
    contrastText: '#25272D',
  },
  warning: {
    main: '#ED6C02',
    dark: '#cb5c02',
    light: '#FF9800',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#215EB2',
    dark: '#1a4a8d',
    light: '#2771d8',
    contrastText: '#25272D',
  },
  text: {
    primary: '#25272D',
    secondary: '#4E4F52',
    disabled: '#A0A0A0',
  },
  background: {
    paper: '#e9f5e3',
    default: '#FFFFFF',
  },
  backgroundHeader: {
    main: '#25272D',
  },
  border: {
    main: '#E1E1E1',
    dark: '#A0A0A0',
    contrastText: '#000000',
  },
  icon: {
    main: '#ECFF9F',
  },
  surveyStepLine: {
    main: '#DBDBDB',
  },
};

export default palette;
